import React from 'react'
import styles from './index.module.sass'
// import { Simulation } from 'types/data';
import { AsideRightProps } from '..';
import { CONTENT } from 'constants/animationConstants';
import { Steps } from './Steps';

interface ContentProps extends AsideRightProps {
    opened: Boolean
}


const Content: React.FunctionComponent<ContentProps> = ({
    simulation: { title, subTitle, dialogs, hideToggler },
    tip: { text },
    goToNextSimulation,
    activeSimulationType,
    opened,
    activeDialogType,
    activeStep,
    positionReady,
    activeSimulation
}) => {
    const activeText = dialogs[activeSimulationType]!.find(item => item.type === activeDialogType)
    const steps = activeText!.steps
    const content = activeText!.content
    const isEnd = activeDialogType === 'END_DIALOG'

    return(
        <div className={`${styles.contentWrapper}`} data-type={CONTENT}>
            <div className={`${opened ? '' : styles.innerWrapper} ${styles.contentContainer}`}>
                        <Steps items={steps || content!} active={activeStep}/>
                        <div className={styles.title}>
                            <p>{title}</p>
                            <p className={styles.subTitle}>{subTitle}</p>
                        </div>
                        <div className={styles.text}>
                            {
                                steps ? 
                                    steps![activeStep].content.map((item, i) => (
                                        <p key={i} dangerouslySetInnerHTML={{__html: item.value}}></p>
                                    ))
                                    :
                                    content ? 
                                        content.map((item, i) => {
                                            const isButton = item.type === 'CONTENT_BUTTON' 
                                            return (
                                                <p key={i} 
                                                    dangerouslySetInnerHTML={{ __html: item.value }} 
                                                    className={`${isButton ? styles.nextStep : ''}`}
                                                    onClick={isButton && positionReady? () => goToNextSimulation!() : () => {}}
                                                >
                                                </p>);
                                        })
                                        :
                                        null
                            }
                        </div>
                        <div className={styles.tips}>
                            <p>{!hideToggler && !isEnd ? text[activeSimulationType] : ''}</p>
                        </div>
                    
            </div>
        </div>
    )
}

export default Content